import Entity from "./entity";

export default class Product extends Entity<number> {
  orderNo: number;
  sku: string;
  name: string;
  clientCode: string;
  unitId: number;
  categoryId: number;
  storageType: string;
  inventModel: string;
  type: string;
  sizeDefCode: string;
  externalCode: string;
  thumbnailUrl: string;
  length: number;
  width: number;
  height: number;
  weight: number;
  color: string;
  qtyPerCase: number;
  caseLength: number;
  caseWidth: number;
  caseHeight: number;
  caseWeight: number;
  isActive: boolean;
  parentId: number;
  brandId: number;
  madeIn: string;
  lengthOfSerialNo: number;
  isAccessories: boolean;
  isWarranty: boolean;
  warrantyDuration: number;
  isTakenBack: boolean;
  productType: string;
  note: string;
  tax: number;
  thumbnailUrlNew: string;
  items: Array<any>;
}
